// Dependencies
import React from "react";

// Modules
import { withRouter } from "react-router"
import { connect } from "react-redux";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

// App
import { serverUrl, apiEndpoints } from "../../config";
import { getOnlineNode } from "../../core/getNode";
import { postNode } from "../../core/postNode";
import { deleteRequest } from "../../core/delete";
import PostTitle from "../../partials/postTitle";
import PostBody from "../../partials/postBody";
import { alertMessages } from "../../partials/alertMessages";
import Error from "../../partials/error";
import SkeletonSingleScreen from "../../partials/skeleton-screens/skeletonSingleScreen";
import CommentSection from "../../partials/comments/commentSection";
import { formatTime } from "../../utils/helpers";

// UI components
import { Row, Col, Container } from 'react-bootstrap';
import { ArrowBack } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Link } from "react-router-dom";
import { Chip, Typography, FormGroup, FormControlLabel, Checkbox, Button, Dialog, DialogContent, Box, IconButton, sliderClasses } from "@mui/material";
import CompanyappLoader from "../../partials/companyappLoader";
import SinglesHeader from "../../partials/singlesHeader";

// Dummy data

export default function QuizSingle(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [isPaginating, setIsPaginating] = useState(false);
  const [post, setPost] = useState(null);
  const [isCommentsLoading, setIsCommentsLoading] = useState(true);
  const [comments, setComments] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [total_pages, setTotal_Pages] = useState(0);
  const [isReactionsLoading, setIsReactionsLoading] = useState(true);
  const [categoryName, setCategoryName] = useState(null);

  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [quiz, setQuiz] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [questionsTrigger, setQuestionsTrigger] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [questionsLoading, setQuestionsLoading] = useState(true);
  const [submissionId, setSubmissionId] = useState();
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [submission, setSubmission] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const user = useSelector((state) => state).authReducer.user;
  const params = useParams();


  useEffect(() => {
    loadNode();
    getQuiz(params.id);
    onSuccess();
  }, []);

  // useEffect(() => {
  //   if (post) {
  //     getCategory()
  //   }
  // }, [post]);

  useEffect(() => {
    if (questionsTrigger && questionsTrigger.length > 0) {
      getAnswer()
    }
  }, [questionsTrigger]);

  useEffect(() => {
    if (submissionId) {
      getSubmission(submissionId)
    }
  }, [submissionId]);


  /**
   * @function setData
   * @description Updates the state of the component upon data retrieval
   * @param {object} _data
   * @param {object} _realm
   */

  const setData = (_data) => {
    setPost(_data);
    setIsLoading(false);
    setIsError(false);
    // getComments();
    // getReactions();
    getCategory(_data.field_category);
  }

  /**
   * @function setError
   * @description Updates the state of the component upon an error
   * @param {boolean} _isError
   * @param {int} _errorStatus
   * @param {string} _errorMessage
   */
  const setError = (_isError, _errorStatus, _errorMessage) => {
    setIsLoading(false);
    setIsError(_isError);
    setErrorStatus(_errorStatus);
    setErrorMessage(_errorMessage);
  };

  const loadNode = () => {
    const nid = params.id;

    if (nid) {
      getContent(nid);
      // getComments(nid)
    } else {
      setError(true, 0, alertMessages.contentError);
    }
  };

  /**
   * @function getContent
   * @description Retrieves the data from an API / Fallback to local realm object if there is no connection
   */
  const getContent = (nid) => {
    let path = `${apiEndpoints.quiz}/all/${nid}?_format=json&status=1&promote=1`;

    getOnlineNode(path)
      .then((response) => {
        if (response.data.rows.length > 0) {
          setData(response.data.rows[0]);
        } else {
          setError(true, 200, alertMessages.noData);
        }
      })
      .catch((_error) => {
        if (_error.response) {
          setError(
            true,
            _error.response.status,
            _error.response.statusText,
          );
        }
        else if (_error.request) {
          setError(true, 0, alertMessages.requestError.message);
        }
        else {
          // setError(true, 0, alertMessages.unknownError.message);
        }
      });
  };

  const getCategory = (id) => {
    // if (post.field_category) {
    //   getOnlineNode(
    //     // `api/categories?vid=news`,
    //     `api/categories?tid=${post.field_category}`,
    //     user.access_token,
    //   )
    //     .then((response) => {
    //       let categoryTemp = response.data.length > 0 ? response.data[0] : { title: "" }
    //       setCategoryName(categoryTemp.title)
    //     })
    //     .catch((_error) => {
    //       if (_error.response) {
    //         setError(
    //           true,
    //           _error.response.status,
    //           _error.response.statusText,
    //         );
    //       } else if (_error.request) {
    //         //console.log("@rest request: ", _error.request);
    //         setError(true, 0, alertMessages.requestError.message);
    //       } else {
    //         //console.log("@rest unknown: ", _error);
    //         // setError(true, 0, alertMessages.unknownError.message);
    //       }
    //     });
    // }
  }


  const getQuiz = (nid) => {
    let path = "api/quiz/questions/" + nid + "?_format=json";

    getOnlineNode(path)
      .then((response) => {
        setQuiz(response.data.quiz)
      })
      .catch((_error) => {
        if (_error.response) {
          setError(
            true,
            _error.response.status,
            _error.response.statusText,
          );
        }
        else if (_error.request) {
          setError(true, 0, alertMessages.requestError.message);
        } else {
          // setError(true, 0, alertMessages.unknownError.message);
        }
      });
  };

  const checkSubmission = (nid) => {
    let path = `api/quiz/check/${user.current_user.uid}/${nid}`;

    getOnlineNode(path)
      .then((response) => {
        if (response.data.length > 0) {
          setSubmissionId(response.data[0].nid)
        }
      })
      .catch((_error) => {
        if (_error.response) {
          setError(
            true,
            _error.response.status,
            _error.response.statusText,
          );
        }
        else if (_error.request) {
          setError(true, 0, alertMessages.requestError.message);
        } else {
          // setError(true, 0, alertMessages.unknownError.message);
        }
      });
  }

  const getSubmission = (nid) => {
    let path = `api/quiz/submission/${nid}`;

    getOnlineNode(path)
      .then((response) => {
        setSubmission({
          status: true,
          answers: response.data
        });
      })
      .catch((_error) => {
        if (_error.response) {
          setError(
            true,
            _error.response.status,
            _error.response.statusText,
          );
        }
        else if (_error.request) {
          setError(true, 0, alertMessages.requestError.message);
        } else {
          // setError(true, 0, alertMessages.unknownError.message);
        }
      });
  }

  const getQuestion = (nid) => {
    let path = `api/quiz_questions/${nid}`;

    getOnlineNode(path)
      .then((response) => {
        setQuestions(response.data.rows);
        setQuestionsTrigger(response.data.rows);
      })
      .catch((_error) => {
        if (_error.response) {
          setError(
            true,
            _error.response.status,
            _error.response.statusText,
          );
        }
        else if (_error.request) {
          setError(true, 0, alertMessages.requestError.message);
        } else {
          // setError(true, 0, alertMessages.unknownError.message);
        }
      });
  }

  const getAnswer = () => {
    let path = `api/quiz_answers/${questionsTrigger[0].id}`;
    let tempArr = [...questionsTrigger];
    getOnlineNode(path)
      .then((response) => {
        let newArr = answers.concat(response.data.rows);
        setAnswers(newArr);
        tempArr.shift();
        if (tempArr.length === 0) {
          setQuestionsLoading(false)
        }
        setQuestionsTrigger(tempArr);
      })
      .catch((_error) => {
        if (_error.response) {
          setError(
            true,
            _error.response.status,
            _error.response.statusText,
          );
        }
        else if (_error.request) {
          setError(true, 0, alertMessages.requestError.message);
        } else {
          // setError(true, 0, alertMessages.unknownError.message);
        }
      });
  }

  const renderPostImage = (post) => {
    const img = post.field_featured_image ? post.field_featured_image : post.uri;

    if (img) {
      return (
        <div className="article__image">
          <img src={`${serverUrl}/${img}`} alt={'img-' + post.nid} />
        </div>
      );
    }
  };

  const renderQuestions = (data) => {
    return (
      <>
        {questionsLoading ?
          <CompanyappLoader />
          :
          <>
            <Row className="w-100 quiz-container ">
              <Col className="quiz-section">
                {data.length > 0 && data.map((e, i) => {
                  let quizAnswers = quiz.find((f) => f.question === e.field_question)?.correct_answers
                  return (
                    <>
                      <Row className="pt-4">
                        <Typography
                          className="question-header mb-2"
                          owner="client"
                          variant="h6"
                          color="clientPrimary.main"
                        >
                          {e.field_question}
                        </Typography>
                      </Row>
                      {!submission.status &&
                        <Row>
                          <Typography
                            className="question-header mb-2"
                            owner="client"
                            variant="body2"
                            color="clientText.main"
                          >
                            *Please choose {quizAnswers.length} {quizAnswers.length > 1 ? "answers" : "answer"}
                          </Typography>
                        </Row>
                      }
                      <Row className="ps-4 question-options-container pb-4 pt-2">
                        {renderOptions(e)}
                      </Row>
                    </>
                  )
                })}
              </Col>
            </Row>
            <Row className="my-3">
              <Col xs="auto">
                <Typography
                  className="question-header mb-2"
                  owner="client"
                  variant="body1"
                  color="clientText.main"
                  weight="light"
                >
                  Please note: You need to answer all the questions before you are able to submit.
                </Typography>
              </Col>
            </Row>
            {!submission.status &&
              <Row className="d-flex justify-content-end w-100 pb-4 mb-4">
                <Col xs={"auto"}>
                  <Button
                    variant="contained"
                    color="clientPrimary"
                    disabled={disableSubmit}
                    onClick={() => setShowConfirmation(true)}
                  >
                    <Typography
                      owner="client"
                      variant="h6"
                      color="clientText.contrastText"
                      lh="medium"
                    >
                      Submit
                    </Typography>
                  </Button>
                </Col>
              </Row>
            }
          </>
        }
      </>
    )
  }

  const renderOptions = (parentQuestion) => {
    let optionsArr = answers.filter((e) => { return e.parent_id === parentQuestion.id });

    return (
      <FormGroup>
        {optionsArr.map((e, i) => {
          let checked, style
          if (submission.status) {
            if (submission?.answers?.find((g) => (g.field_answer === e.field_answer && g.field_question_id === parentQuestion.id))) {
              checked = true
            }
            else {
              checked = false
            }
            if (e.field_correct === "Yes") {
              style = {
                color: "#66bb6a",
              }
            } else if (e.field_correct === "No" && checked) {
              style = {
                color: "#f44336",
              }
            }
          }

          return (
            <FormControlLabel
              control={
                <Checkbox
                  color="clientPrimary"
                  disabled={submission.status || selectedAnswers[parentQuestion.id]?.limitReached && !selectedAnswers[parentQuestion.id].answers.find((f) => f.id === e.id)}
                  onChange={(event) => handleAnswer(event.target.checked, e, parentQuestion)}
                  checked={checked}
                  style={style}
                />
              }
              label={
                <Typography
                  owner="client"
                  variant="body1"
                  style={style}
                >
                  {e.field_answer}
                </Typography>
              }
            />
          )
        })}
      </FormGroup>
    )
  }

  const renderConfirmDialog = () => {
    return (
      <Dialog
        className="form-dialog ps-modal"
        open={showConfirmation}
        onClose={() => setShowConfirmation(false)}
      >

        <Box className='ps-modal-title'>
          <Container fluid>
            <Row className='d-flex align-items-center justify-content-between'>
              <Col xs={"auto"}>
                <Typography variant='h3' owner='client' color='clientText.dark'>Important</Typography>
              </Col>
              <Col xs={"auto"}>
                <IconButton
                  className="close-dialog-btn"
                  onClick={() => setShowConfirmation(false)}
                >
                  <CloseIcon />
                </IconButton>
              </Col>
            </Row>
          </Container>
        </Box>
        <DialogContent className="form-dialog-content ps-modal-content" sx={{ position: 'relative' }}>
          <Container fluid>
            <Row>
              <Typography
                owner="client"
                variant="body1"
              >
                Once submitted you can no longer change your answers for this test
              </Typography>
            </Row>
            <Row
              className="d-flex justify-content-center my-3"
            >
              <Col
                xs={"auto"}
              >
                <Button
                  variant="contained"
                >
                  <Typography
                    owner="client"
                    variant="button"
                    onClick={() => onSubmit()}
                  >
                    Submit
                  </Typography>
                </Button>
              </Col>
            </Row>
          </Container>
        </DialogContent>
      </Dialog>
    )
  }

  const handleAnswer = (status, option, parentQuestion) => {
    let tempSelectedAnswers = { ...selectedAnswers };
    let limit = quiz.find((e) => e.question === parentQuestion.field_question)?.correct_answers.length;
    console.log("limit", limit);
    if (status) {
      // check if question exists
      if (!tempSelectedAnswers[parentQuestion.id]) {
        // if not, create new
        tempSelectedAnswers[parentQuestion.id] = {
          question: parentQuestion,
          answers: [{ ...option }],
          limitReached: limit === 1 ? true : false
        };
      } else {
        tempSelectedAnswers[parentQuestion.id].answers.push(option)
        if (tempSelectedAnswers[parentQuestion.id].answers.length === limit) {
          tempSelectedAnswers[parentQuestion.id].limitReached = true;
        }
      }
      setSelectedAnswers(tempSelectedAnswers);
    }
    else if (!status) {
      // check if question exists

      if (tempSelectedAnswers[parentQuestion.id]) {
        // if not, create new
        let answersArr = tempSelectedAnswers[parentQuestion.id].answers
        let answerIndex = answersArr.findIndex((e) => e.id === option.id);
        answersArr.splice(answerIndex, 1);
        if (answersArr.length > 0) {
          tempSelectedAnswers[parentQuestion.id].answers = answersArr;
        }
        else {
          delete tempSelectedAnswers[parentQuestion.id];
        }
      } else {
        console.error("invalid action");
      }
      setSelectedAnswers(tempSelectedAnswers);
    }
    checkComplete(tempSelectedAnswers);
  }

  const checkComplete = (_selectedAnswers) => {
    let questionsAnswered = 0;
    questions.forEach((e) => {
      if (_selectedAnswers[e.id] && _selectedAnswers[e.id]?.limitReached) {
        questionsAnswered++;
      }
    });
    if (questionsAnswered === questions.length) {
      setDisableSubmit(false);
    }
    else {
      setDisableSubmit(true);
    }
  }

  const saveNode = () => {
    let answerKeys = Object.keys(selectedAnswers);
    let payloadQuestions = []

    answerKeys.forEach((e) => {
      let answersArr = []
      selectedAnswers[e].answers.forEach((f) => {
        answersArr.push({
          field_answer: f.field_answer,
          field_correct: f.field_correct
        })
      });
      payloadQuestions.push({
        field_question: selectedAnswers[e].question.field_question,
        answers: answersArr
      })
    });


    let payload = {
      quizID: params.id,
      questions: payloadQuestions
    }
    postNode("/api/quiz/submission", payload, user.csrf_token)
      .then((response) => {
        if (response.status === 200) {
          onSuccess()
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const onSubmit = () => {
    setQuestionsLoading(true);
    setShowConfirmation(false);
    saveNode();
  }

  const onSuccess = () => {
    setSelectedAnswers([]);
    setAnswers([]);
    getQuestion(params.id);
    checkSubmission(params.id);
  }

  if (isLoading) {
    return <SkeletonSingleScreen />;
  } else {
    if (isError) {
      return (
        <Error
          status={errorStatus}
          message={errorMessage}
        />
      );
    } else {
      let category = "Uncategorised";

      // if (categoryName) {
      //   category = categoryName;
      // }

      // if (post.categoryLabel) {
      //   category = post.categoryLabel;
      // }

      return (
        <main className="quizzes  single">
          <article className="article">
            <SinglesHeader
              route={"/quizzes"}
              backBtnText={"Tests & Quizzes"}
              category={category}
              timestamp={post.created}
              title={post.title}
            />
            {renderPostImage(post)}
            <div className="article__body">
              <PostBody body={post.body} />
            </div>
            {questions.length > 0 ? renderQuestions(questions) : ""}
          </article>
          {renderConfirmDialog()}
        </main>
      );
    }
  }
}

